import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_CHALLENGE, SET_CHALLENGE_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchChallenge = createAction(FETCH_CHALLENGE.CLEANUP)

export const setChallengePageIsDirty = createPayloadAction(
  SET_CHALLENGE_PAGE_TO_DIRTY,
)
